// source: pbtypes/gen/surface_scan/surface_scan_analytics.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_gen_scan_planner_component_request_pb = require('../../../pbtypes/gen/scan_planner/component_request_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_component_request_pb);
var pbtypes_gen_skills_gps_waypoint_pb = require('../../../pbtypes/gen/skills/gps_waypoint_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_gps_waypoint_pb);
var pbtypes_gen_surface_scan_scan_health_fault_pb = require('../../../pbtypes/gen/surface_scan/scan_health_fault_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_scan_health_fault_pb);
var pbtypes_gen_surface_scan_scan_mode_pb = require('../../../pbtypes/gen/surface_scan/scan_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_scan_mode_pb);
var pbtypes_gen_surface_scan_settings_manager_pb = require('../../../pbtypes/gen/surface_scan/settings_manager_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_settings_manager_pb);
var pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb = require('../../../pbtypes/gen/surface_scan/surface_scan_camera_analytics_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb);
var pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb = require('../../../pbtypes/gen/surface_scan/surface_scan_flight_analytics_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb);
var pbtypes_gen_surface_scan_surface_scan_status_pb = require('../../../pbtypes/gen/surface_scan/surface_scan_status_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_surface_scan_status_pb);
goog.exportSymbol('proto.surface_scan.SurfaceScanAnalytics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.surface_scan.SurfaceScanAnalytics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.surface_scan.SurfaceScanAnalytics.repeatedFields_, null);
};
goog.inherits(proto.surface_scan.SurfaceScanAnalytics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.surface_scan.SurfaceScanAnalytics.displayName = 'proto.surface_scan.SurfaceScanAnalytics';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.surface_scan.SurfaceScanAnalytics.repeatedFields_ = [6,12,18];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.toObject = function(opt_includeInstance) {
  return proto.surface_scan.SurfaceScanAnalytics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.surface_scan.SurfaceScanAnalytics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanAnalytics.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
scanSkillStateId: jspb.Message.getFieldWithDefault(msg, 2, ""),
scanMode: jspb.Message.getFieldWithDefault(msg, 3, 0),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
resumeStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
activeScanFaultsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
name: jspb.Message.getFieldWithDefault(msg, 7, ""),
description: jspb.Message.getFieldWithDefault(msg, 8, ""),
isImperial: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
backtrackButtonId: jspb.Message.getFieldWithDefault(msg, 10, ""),
settings: (f = msg.getSettings()) && pbtypes_gen_surface_scan_settings_manager_pb.SettingsManager.toObject(includeInstance, f),
componentSettingsList: jspb.Message.toObjectList(msg.getComponentSettingsList(),
    pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.toObject, includeInstance),
reportName: jspb.Message.getFieldWithDefault(msg, 13, ""),
baseHref: jspb.Message.getFieldWithDefault(msg, 14, ""),
featureImagePath: jspb.Message.getFieldWithDefault(msg, 15, ""),
defaultGps: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
gpsScanPosition: (f = msg.getGpsScanPosition()) && pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.toObject(includeInstance, f),
flightsList: jspb.Message.toObjectList(msg.getFlightsList(),
    pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb.SurfaceScanFlightAnalytics.toObject, includeInstance),
gsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
effectiveGsd: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
flightCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
flightTime: jspb.Message.getFieldWithDefault(msg, 21, 0),
imageCountAutonomous: jspb.Message.getFieldWithDefault(msg, 22, 0),
imageCountManual: jspb.Message.getFieldWithDefault(msg, 23, 0),
imageCountTotalAllFormats: jspb.Message.getFieldWithDefault(msg, 28, 0),
pillarCount: jspb.Message.getFieldWithDefault(msg, 24, 0),
scanArea: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
cameraAnalytics: (f = msg.getCameraAnalytics()) && pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb.SurfaceScanCameraAnalytics.toObject(includeInstance, f),
isMissionAction: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
wasStuckDuringScan: jspb.Message.getBooleanFieldWithDefault(msg, 29, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.surface_scan.SurfaceScanAnalytics}
 */
proto.surface_scan.SurfaceScanAnalytics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.surface_scan.SurfaceScanAnalytics;
  return proto.surface_scan.SurfaceScanAnalytics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.surface_scan.SurfaceScanAnalytics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.surface_scan.SurfaceScanAnalytics}
 */
proto.surface_scan.SurfaceScanAnalytics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSkillStateId(value);
      break;
    case 3:
      var value = /** @type {!proto.surface_scan.ScanMode.Enum} */ (reader.readEnum());
      msg.setScanMode(value);
      break;
    case 4:
      var value = /** @type {!proto.surface_scan.SurfaceScanStatus.Enum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.surface_scan.SurfaceScanStatus.Enum} */ (reader.readEnum());
      msg.setResumeStatus(value);
      break;
    case 6:
      var values = /** @type {!Array<!proto.surface_scan.ScanHealthFault.Enum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addActiveScanFaults(values[i]);
      }
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsImperial(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBacktrackButtonId(value);
      break;
    case 11:
      var value = new pbtypes_gen_surface_scan_settings_manager_pb.SettingsManager;
      reader.readMessage(value,pbtypes_gen_surface_scan_settings_manager_pb.SettingsManager.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 12:
      var value = new pbtypes_gen_scan_planner_component_request_pb.ComponentRequest;
      reader.readMessage(value,pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.deserializeBinaryFromReader);
      msg.addComponentSettings(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setReportName(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBaseHref(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeatureImagePath(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultGps(value);
      break;
    case 17:
      var value = new pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint;
      reader.readMessage(value,pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.deserializeBinaryFromReader);
      msg.setGpsScanPosition(value);
      break;
    case 18:
      var value = new pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb.SurfaceScanFlightAnalytics;
      reader.readMessage(value,pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb.SurfaceScanFlightAnalytics.deserializeBinaryFromReader);
      msg.addFlights(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGsd(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setEffectiveGsd(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setFlightCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setFlightTime(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setImageCountAutonomous(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setImageCountManual(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setImageCountTotalAllFormats(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPillarCount(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScanArea(value);
      break;
    case 26:
      var value = new pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb.SurfaceScanCameraAnalytics;
      reader.readMessage(value,pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb.SurfaceScanCameraAnalytics.deserializeBinaryFromReader);
      msg.setCameraAnalytics(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMissionAction(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWasStuckDuringScan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.surface_scan.SurfaceScanAnalytics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.surface_scan.SurfaceScanAnalytics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.SurfaceScanAnalytics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getScanSkillStateId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getScanMode();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getResumeStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getActiveScanFaultsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIsImperial();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getBacktrackButtonId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      pbtypes_gen_surface_scan_settings_manager_pb.SettingsManager.serializeBinaryToWriter
    );
  }
  f = message.getComponentSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      pbtypes_gen_scan_planner_component_request_pb.ComponentRequest.serializeBinaryToWriter
    );
  }
  f = message.getReportName();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBaseHref();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getFeatureImagePath();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getDefaultGps();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getGpsScanPosition();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint.serializeBinaryToWriter
    );
  }
  f = message.getFlightsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      18,
      f,
      pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb.SurfaceScanFlightAnalytics.serializeBinaryToWriter
    );
  }
  f = message.getGsd();
  if (f !== 0.0) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = message.getEffectiveGsd();
  if (f !== 0.0) {
    writer.writeFloat(
      30,
      f
    );
  }
  f = message.getFlightCount();
  if (f !== 0) {
    writer.writeSint32(
      20,
      f
    );
  }
  f = message.getFlightTime();
  if (f !== 0) {
    writer.writeSint64(
      21,
      f
    );
  }
  f = message.getImageCountAutonomous();
  if (f !== 0) {
    writer.writeSint32(
      22,
      f
    );
  }
  f = message.getImageCountManual();
  if (f !== 0) {
    writer.writeSint32(
      23,
      f
    );
  }
  f = message.getImageCountTotalAllFormats();
  if (f !== 0) {
    writer.writeSint32(
      28,
      f
    );
  }
  f = message.getPillarCount();
  if (f !== 0) {
    writer.writeSint32(
      24,
      f
    );
  }
  f = message.getScanArea();
  if (f !== 0.0) {
    writer.writeFloat(
      25,
      f
    );
  }
  f = message.getCameraAnalytics();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb.SurfaceScanCameraAnalytics.serializeBinaryToWriter
    );
  }
  f = message.getIsMissionAction();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getWasStuckDuringScan();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string scan_skill_state_id = 2;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getScanSkillStateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setScanSkillStateId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ScanMode.Enum scan_mode = 3;
 * @return {!proto.surface_scan.ScanMode.Enum}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getScanMode = function() {
  return /** @type {!proto.surface_scan.ScanMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.surface_scan.ScanMode.Enum} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setScanMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional SurfaceScanStatus.Enum status = 4;
 * @return {!proto.surface_scan.SurfaceScanStatus.Enum}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getStatus = function() {
  return /** @type {!proto.surface_scan.SurfaceScanStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.surface_scan.SurfaceScanStatus.Enum} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional SurfaceScanStatus.Enum resume_status = 5;
 * @return {!proto.surface_scan.SurfaceScanStatus.Enum}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getResumeStatus = function() {
  return /** @type {!proto.surface_scan.SurfaceScanStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.surface_scan.SurfaceScanStatus.Enum} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setResumeStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * repeated ScanHealthFault.Enum active_scan_faults = 6;
 * @return {!Array<!proto.surface_scan.ScanHealthFault.Enum>}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getActiveScanFaultsList = function() {
  return /** @type {!Array<!proto.surface_scan.ScanHealthFault.Enum>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.surface_scan.ScanHealthFault.Enum>} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setActiveScanFaultsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.surface_scan.ScanHealthFault.Enum} value
 * @param {number=} opt_index
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.addActiveScanFaults = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearActiveScanFaultsList = function() {
  return this.setActiveScanFaultsList([]);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string description = 8;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool is_imperial = 9;
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getIsImperial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setIsImperial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional string backtrack_button_id = 10;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getBacktrackButtonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setBacktrackButtonId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional SettingsManager settings = 11;
 * @return {?proto.surface_scan.SettingsManager}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getSettings = function() {
  return /** @type{?proto.surface_scan.SettingsManager} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_surface_scan_settings_manager_pb.SettingsManager, 11));
};


/**
 * @param {?proto.surface_scan.SettingsManager|undefined} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
*/
proto.surface_scan.SurfaceScanAnalytics.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated scan_planner.ComponentRequest component_settings = 12;
 * @return {!Array<!proto.scan_planner.ComponentRequest>}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getComponentSettingsList = function() {
  return /** @type{!Array<!proto.scan_planner.ComponentRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_scan_planner_component_request_pb.ComponentRequest, 12));
};


/**
 * @param {!Array<!proto.scan_planner.ComponentRequest>} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
*/
proto.surface_scan.SurfaceScanAnalytics.prototype.setComponentSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.scan_planner.ComponentRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.scan_planner.ComponentRequest}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.addComponentSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.scan_planner.ComponentRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearComponentSettingsList = function() {
  return this.setComponentSettingsList([]);
};


/**
 * optional string report_name = 13;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getReportName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setReportName = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string base_href = 14;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getBaseHref = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setBaseHref = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string feature_image_path = 15;
 * @return {string}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getFeatureImagePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setFeatureImagePath = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool default_gps = 16;
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getDefaultGps = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setDefaultGps = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional skills.GpsWaypoint gps_scan_position = 17;
 * @return {?proto.skills.GpsWaypoint}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getGpsScanPosition = function() {
  return /** @type{?proto.skills.GpsWaypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_skills_gps_waypoint_pb.GpsWaypoint, 17));
};


/**
 * @param {?proto.skills.GpsWaypoint|undefined} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
*/
proto.surface_scan.SurfaceScanAnalytics.prototype.setGpsScanPosition = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearGpsScanPosition = function() {
  return this.setGpsScanPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.hasGpsScanPosition = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * repeated SurfaceScanFlightAnalytics flights = 18;
 * @return {!Array<!proto.surface_scan.SurfaceScanFlightAnalytics>}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getFlightsList = function() {
  return /** @type{!Array<!proto.surface_scan.SurfaceScanFlightAnalytics>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_surface_scan_surface_scan_flight_analytics_pb.SurfaceScanFlightAnalytics, 18));
};


/**
 * @param {!Array<!proto.surface_scan.SurfaceScanFlightAnalytics>} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
*/
proto.surface_scan.SurfaceScanAnalytics.prototype.setFlightsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 18, value);
};


/**
 * @param {!proto.surface_scan.SurfaceScanFlightAnalytics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.surface_scan.SurfaceScanFlightAnalytics}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.addFlights = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.surface_scan.SurfaceScanFlightAnalytics, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearFlightsList = function() {
  return this.setFlightsList([]);
};


/**
 * optional float gsd = 19;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional float effective_gsd = 30;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getEffectiveGsd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setEffectiveGsd = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional sint32 flight_count = 20;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getFlightCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setFlightCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional sint64 flight_time = 21;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getFlightTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setFlightTime = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional sint32 image_count_autonomous = 22;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getImageCountAutonomous = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setImageCountAutonomous = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional sint32 image_count_manual = 23;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getImageCountManual = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setImageCountManual = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional sint32 image_count_total_all_formats = 28;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getImageCountTotalAllFormats = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setImageCountTotalAllFormats = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional sint32 pillar_count = 24;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getPillarCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setPillarCount = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional float scan_area = 25;
 * @return {number}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getScanArea = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setScanArea = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional SurfaceScanCameraAnalytics camera_analytics = 26;
 * @return {?proto.surface_scan.SurfaceScanCameraAnalytics}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getCameraAnalytics = function() {
  return /** @type{?proto.surface_scan.SurfaceScanCameraAnalytics} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_surface_scan_surface_scan_camera_analytics_pb.SurfaceScanCameraAnalytics, 26));
};


/**
 * @param {?proto.surface_scan.SurfaceScanCameraAnalytics|undefined} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
*/
proto.surface_scan.SurfaceScanAnalytics.prototype.setCameraAnalytics = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.clearCameraAnalytics = function() {
  return this.setCameraAnalytics(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.hasCameraAnalytics = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool is_mission_action = 27;
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getIsMissionAction = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setIsMissionAction = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool was_stuck_during_scan = 29;
 * @return {boolean}
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.getWasStuckDuringScan = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.SurfaceScanAnalytics} returns this
 */
proto.surface_scan.SurfaceScanAnalytics.prototype.setWasStuckDuringScan = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


goog.object.extend(exports, proto.surface_scan);
